import store from '../../redux/store'
import { setMyUserInfo, setFetchingStatus } from '../../redux/actions'
import { message } from '../../components/common/alert'
import i18next from "i18next";
import { createBrowserHistory  } from 'history'
import { rootStore } from 'agora-chat-uikit'
import { AGORA_CHAT_APP_NAME, AGORA_CHAT_ORG_NAME } from '../../utils/constant';
const history = createBrowserHistory ()
export const getToken = (agoraId, password) => {
    return postData(`https://a41.chat.agora.io/${AGORA_CHAT_ORG_NAME}/${AGORA_CHAT_APP_NAME}/token`, { "username": agoraId, "password": "12345678" , "grant_type": "password" })
}

export const signUp = (agoraId, password) => {
    return postData(`https://a41.chat.agora.io/${AGORA_CHAT_ORG_NAME}/${AGORA_CHAT_APP_NAME}/users`, { "username": agoraId, "password": "12345678" })
}

export const loginWithToken = (agoraId, accessToken) => {
    let options = {
        user: agoraId,
        accessToken: accessToken
    };

    return new Promise((resolve, reject) => {
        rootStore.client.open(options).then(res => {
            rootStore.client.context.userId = agoraId;
            rootStore.client.fetchUserInfoById(agoraId).then(val => {
                const res = val.data || {}
                if(res[agoraId]?.nickname) {
                    store.dispatch(setMyUserInfo({ nickName: res[agoraId]?.nickname || '' }))
                }
            })
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

export function postData(url, data) {
    return fetch(url, {
        body: JSON.stringify(data),
        cache: 'no-cache',
        headers: {
            'content-type': 'application/json',
             "Authorization": "Bearer " + "007eJxTYEi70nqv/Kwml+jrZP6+a39k9U3e3//ifuP5ba7QH8ZKl3coMCQnGlgkppmlWZqbppqkGSRaJiUmJhsngwVSzC2THZ4uymgIZGSYa3WAkZGBlYGRgYkBxGdgAAAz8iCH"
        },

        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer',
    })
        .then(response => response.json())
}

export const loginWithPassword = (agoraId, password) => {
    let options = {
        user: agoraId,
        pwd: password
    };
    rootStore.client.open(options).then((res) => {
        const { accessToken } = res
        store.dispatch(setMyUserInfo({ agoraId, password }))
        sessionStorage.setItem('webim_auth', JSON.stringify({ agoraId, password, accessToken }))
    }).catch((err) => {
        store.dispatch(setFetchingStatus(false))
        // message.error('login fail.')
    })
}


export function logout() {
    rootStore.client.close()
    sessionStorage.removeItem('webim_auth')
    rootStore.clear()
    window.document.title = 'Lyncspot chat'

}

export function register(agoraId, password, nickname) {
    let options = {
        // appKey: WebIM.config.appkey,
        // apiUrl: WebIM.config.restServer,
        username: agoraId,
        password: password,
        nickname: nickname ? nickname.trim().toLowerCase() : '',
        success: function () {
            store.dispatch(setFetchingStatus(false))
            store.dispatch(setMyUserInfo({ agoraId, password }))
            sessionStorage.setItem('webim_auth', JSON.stringify({ agoraId, password }))
        },

        error: (err) => {
            store.dispatch(setFetchingStatus(false))
            if (JSON.parse(err.data).error === 'duplicate_unique_property_exists') {
                message.error(i18next.t('UserAlreadyExists'))
            } else if (JSON.parse(err.data).error === 'illegal_argument') {
                if (JSON.parse(err.data).error_description === 'USERNAME_TOO_LONG') {
                    return message.error(i18next.t('UserNameTooLong'))
                } else if (JSON.parse(err.data).error_description === 'password or pin must provided') {
                    return message.error(i18next.t('InvalidPassword'))
                }
                message.error(i18next.t('InvalidUserName'))
            } else if (JSON.parse(err.data).error === 'unauthorized') {
                message.error(i18next.t('SignUpFailed'))
            } else if (JSON.parse(err.data).error === 'resource_limited') {
                message.error(i18next.t('LimitAccount'))
            }
        }
    }
    rootStore.client.registerUser(options)
}
